import React from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Experience } from './components/Experience';
import { Coverage } from './components/Coverage';
import { Expertise } from './components/Expertise';
import { Contact } from './components/Contact';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-300 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <About data-id="element-3" />
        <Experience data-id="element-4" />
        <Coverage data-id="element-5" />
        <Expertise data-id="element-6" />
      </main>
      <Contact data-id="element-7" />
    </div>;
}